import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateSeminaryStats = (state: StatsSnapshot) => {
  const seminary = state.generators.seminary;

  const generatedClerics = seminary.owned * seminary.baseGeneration;

  stats.seminary = {
    unitsGeneration: generatedClerics,
  };
};
